import axios from "./Api";
import { handleQueriesString } from "../helpers/function.helper";

export const GetStoreRequisitiontList = async (params: any) => {
  const queriesString = handleQueriesString(params);
  const url = `/api/app/store-requisition?MaxResultCount=40&${queriesString}`;
  const data = await axios.get(url);
  return data;
};

export const GetStroreRequisitionDetail = async (id: number) => {
  const url = `/api/app/store-requisition/${id}`;
  const data = await axios.get(url);
  return data;
};

export const ExportPdf = async (id: number, params: any) => {
  const url = `/api/app/p-dF/${id}/get-store-requisition-pDF`;
  const data = await axios.post(url, params, { responseType: "blob" });
  return data;
};
